/**
 * Utilitários de data específicos para o módulo de Gamificação
 */

/**
 * Retorna string 'YYYY-MM-DD' com base no calendário local, imune a discrepâncias de horário/timezone
 */
export const toDateOnlyString = (dateInput: Date | string | null | undefined): string => {
  if (!dateInput) return ''
  const d = new Date(dateInput)
  if (isNaN(d.getTime())) return ''
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

/**
 * Retorna ISO string normalizada para o início do dia local (00:00:00.000)
 */
export const toStartOfDayISO = (dateInput: Date | string | null | undefined): string | null => {
  if (!dateInput) return null
  const d = new Date(dateInput)
  if (isNaN(d.getTime())) return null
  d.setHours(0, 0, 0, 0)
  return d.toISOString()
}

/**
 * Retorna ISO string normalizada para o fim do dia local (23:59:59.999)
 */
export const toEndOfDayISO = (dateInput: Date | string | null | undefined): string | null => {
  if (!dateInput) return null
  const d = new Date(dateInput)
  if (isNaN(d.getTime())) return null
  d.setHours(23, 59, 59, 999)
  return d.toISOString()
}

/**
 * Ordena missões cronologicamente por período (startDate/endDate) e por nome natural / ordem alfanumérica
 */
export const sortMissions = <T extends { startDate?: string | null; endDate?: string | null; title?: string; name?: string }>(missions: T[]): T[] => {
  return [...missions].sort((a, b) => {
    const aHasDate = !!a.startDate
    const bHasDate = !!b.startDate

    // 1. Ambas têm data de início: ordena cronologicamente
    if (aHasDate && bHasDate) {
      const aStart = new Date(a.startDate!).getTime()
      const bStart = new Date(b.startDate!).getTime()
      if (aStart !== bStart) {
        return aStart - bStart
      }
      // Mesma data de início: desempata por data de fim
      if (a.endDate && b.endDate) {
        const aEnd = new Date(a.endDate).getTime()
        const bEnd = new Date(b.endDate).getTime()
        if (aEnd !== bEnd) {
          return aEnd - bEnd
        }
      }
    } else if (aHasDate && !bHasDate) {
      // Missão com período vem antes de missão de toda a competição
      return -1
    } else if (!aHasDate && bHasDate) {
      return 1
    }

    // 2. Desempate por nome alfanumérico natural ("1" antes de "2", "Módulo 1" antes de "Módulo 2")
    const nameA = (a.title || a.name || '').trim()
    const nameB = (b.title || b.name || '').trim()
    return nameA.localeCompare(nameB, undefined, { numeric: true, sensitivity: 'base' })
  })
}
